module.exports = __webpack_public_path__ + "static/img/13.d2df5872.png";